// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import gql from 'graphql-tag';

export const EDIT_TASK_GROUP_DATE_MUTATION = gql`
  mutation EditTaskGroupDate($task_id: Int!, $new_time: Int!) {
    editTaskGroupDate(input: { task_id: $task_id, new_time: $new_time }) {
      updated_tasks {
        id
        task_time
        updated_at
      }
    }
  }
`;
